<template>
  <div>
    <div class="bar_title mb-8 shadow-lg">
      <p class="title_bar_text">Gestión</p>
      <p>Realiza búsquedas y asigna gestores</p>
    </div>

    <!-- <div class="flex flex-wrap gap-8 justify-center items-center text-lg">
      <div class="flex items-center gap-2">
        <input
          class="radio_ant"
          type="radio"
          id="option1"
          value="1"
          v-model="type_search"
        />
        <label for="option1" class="cursor-pointer"
          >Búsqueda por rango de valores</label
        >
      </div>

      <div class="flex items-center gap-2">
        <input
          class="radio_ant"
          type="radio"
          id="option3"
          value="3"
          v-model="type_search"
        />
        <label for="option3" class="cursor-pointer"
          >Búsqueda por antiguedad</label
        >
      </div>
    </div>

    <vs-divider /> -->

    <div
      v-if="type_search == 1"
      class="grid grid-cols-1 lg:grid-cols-4 gap-4 lg:gap-6 justify-center items-center my-8"
    >
      <div class="lg:col-span-2 text-center">
        <span
          >MIN &nbsp;&nbsp;&nbsp;&nbsp;Ingrese un rango de
          valores&nbsp;&nbsp;&nbsp;&nbsp;MÁX</span
        >
        <div class="flex w-full items-center gap-4">
          <input type="number" class="input_ena2" v-model="min_range" />
          <input type="number" class="input_ena2" v-model="max_range" />
        </div>
      </div>

      <vs-button
        class="w-full mt-0 lg:mt-6"
        color="secondary"
        icon-pack="feather"
        icon="icon-search"
        :disabled="isSearching"
        @click="search_cobranza()"
        >{{ isSearching ? "Consultando..." : "Buscar" }}</vs-button
      >
    </div>

    <vs-divider />

    <vs-collapse class="mb-6 cobranza-filters-collapse" style="position: relative; z-index: 999">
      <vs-collapse-item class="border_collapse">
        <div slot="header" class="flex flex-col gap-1 md:flex-row md:items-center md:justify-between w-full pr-4">
          <span>Filtros avanzados</span>
          <span class="text-sm text-gray-600">
            {{ activeFilters.length ? `${activeFilters.length} filtro(s) aplicados` : "Sin filtros adicionales" }}
          </span>
        </div>

        <div class="grid grid-cols-2 md:grid-cols-4 gap-5 px-2 py-4">
          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Fecha último pago</label>
            <datepicker name="dateLastPass" v-model="dateLastPass"></datepicker>
          </div>

          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Fecha último viaje</label>
            <datepicker name="dateLastPass" v-model="dateLastPass"></datepicker>
          </div>

          <div class="flex flex-col gap-5">
            <label for="accountType">Tipo de cuenta</label>
            <v-select
              id="accountType"
              class="w-full style-chooser"
              :options="accounts"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="accountType"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="panapass" class="w-full">Panapass</label>
            <input
              id="panapass"
              class="w-full input_ena input_query shadow-lg"
              placeholder="Ingrese el panapass"
              type="text"
              ref="search_field1"
              v-model="search_field1_panapass"
              @input="formatInput"
            />
          </div>

          <div class="flex flex-col gap-5">
            <label for="statusCobranza" class="w-full">Estado de cobro</label>
            <v-select
              id="statusCobranza"
              class="w-full style-chooser"
              :options="cobranza_types"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="status_cobranza"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="gestor">Gestor ENA</label>
            <v-select
              id="gestor"
              class="w-full style-chooser"
              :options="gestores"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="gestor"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="statusEmail" class="w-full">Envío email</label>
            <v-select
              id="statusEmail"
              class="w-full style-chooser"
              :options="status_email_options"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="status_email"
            >
            </v-select>
          </div>

          <div v-if="role && role.role_id == 1" class="flex flex-col gap-5">
            <label for="collector" class="w-full">Cobrador</label>
            <v-select
              id="collector"
              class="w-full style-chooser"
              :options="collectors"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="collector"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Segmento</label>
            <v-select
              class="style-chooser w-full"
              :options="segmentaciones"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="seg_selected"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5 h-full">
            <label for="collector" class="w-full">Antiguedad</label>
            <v-select
              class="style-chooser w-full"
              :options="antiguedades"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="ant_selected"
            >
            </v-select>
          </div>

          <div class="w-100 flex flex-col gap-5">
            <label for="collector" class="w-full">Filtro por titular</label>
            <v-select
              class="style-chooser w-full"
              :options="titulares"
              :append-to-body="true"
              :calculate-position="calculateSelectPosition"
              v-model="titular_selected"
            >
            </v-select>
          </div>
        </div>

        <div class="flex justify-end items-center gap-3 px-2 mt-4 pb-4">
          <vs-button :disabled="isSearching" color="primary" @click="search_with_filters()">{{ isSearching ? "Consultando..." : "Aplicar filtros" }}</vs-button>
          <vs-button :disabled="isSearching" color="warning" type="border" @click="clearFilters()">Limpiar filtros</vs-button>
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <div v-if="activeFilters.length" class="flex flex-wrap gap-2 mb-4" style="position: relative; z-index: 0">
      <span v-for="(filter, index) in activeFilters" :key="index" class="filter-chip">
        {{ filter }}
      </span>
    </div>

    <div
      class="flex gap-10 text-lg text-center md:text-start leading-none md:leading-5 mb-4"
      style="font-weight: 500"
    >
      <span
        >Total saldo actual: <br class="block md:hidden" />
        <span v-if="total_cobranza" style="color: orange">
          {{ total_cobranza | currency }}
        </span>
        <span v-else style="color: orange">
          {{ 0 | currency }}
        </span>
      </span>
      <span
        >Cantidad clientes: <br class="block md:hidden" />
        <span style="color: orange">{{ data_cobranza.length | numberFormat }}</span></span
      >
    </div>

    <vs-divider />

    <balance_data
      v-if="data_cobranza.length > 0"
      @search_cobranza="search_cobranza"
      :data_cobranza="data_cobranza"
      :companies="companies"
      :min_range="min_range"
      :max_range="max_range"
    ></balance_data>
  </div>
</template>
<script>
import axios from "@/axios";
import Swal from "sweetalert2";
import vSelect from "vue-select";
import balance_data from "./partials/balance_data.vue";
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";


export default {
  components: {
    balance_data,
    vSelect,
    Datepicker,
  },
  data() {
    return {
      companies: [],
      users: [],
      config: null,
      min_range_valid: 0,
      min_range: 0,
      max_range_valid: 0,
      max_range: 0,
      total_cobranza: 0,
      data_cobranza: [],
      antiguedades: [],
      segmentaciones: [],
      fechas: [],
      type_search: 1,
      ant_selected: null,
      titular_selected: null,
      seg_selected: null,
      dateLastPass: "",
      dateLastPass: "",
      valorTotal: 0,
      internalValue: "",
      search_field1: "",
      accounts: [
        { label: "Prepago", value: "Prepago" },
        { label: "Prepago recurrente", value: "Prepago recurrente" },
        { label: "Postpago", value: "Postpago" },
        { label: "No afiliados", value: "No Afiliado" },
      ],
      cobranza_types: [
        { label: "Todos", value: '' },
        { label: "Sin Asignar", value: 3 },
        { label: "Asignados Pendientes", value: 'pendientes' },
        { label: "Cobrados", value: 1 },
      ],
      titulares: [
        { label: "Todos", value: 1 },
        { label: "Último titular registrado", value: 2 },
        { label: "Titular asociado a la deuda más antigua o mayor monto", value: 3 },
      ],
      accountType: { label: "", value: "" },
      gestor: { label: "", value: "" },
      gestores: [],
      isSearching: false,
      role: null,
      collector: { label: "", value: "" },
      status_cobranza: { label: "", value: "" },
      collectors: [],
      status_email: { label: "", value: "" },
      status_email_options: [
        { label: "Todos", value: "" },
        { label: "Enviado", value: "1" },
        { label: "No enviado", value: "0" },
      ],
    };
  },
  computed: {
    search_field1_panapass: {
      get() {
        // Si internalValue está vacío, muestra una cadena vacía; de lo contrario, completa con ceros
        return this.internalValue ? this.internalValue.padStart(10, "0") : "";
      },
      set(value) {
        // Elimina ceros a la izquierda y limita el valor a 10 caracteres
        this.internalValue = value.replace(/^0+/, "").slice(0, 10);
      },
    },
    activeFilters() {
      const filters = [];

      if (this.gestor && this.gestor.label) filters.push(`Gestor ENA: ${this.gestor.label}`);
      if (this.accountType && this.accountType.label) filters.push(`Tipo cuenta: ${this.accountType.label}`);
      if (this.status_cobranza && this.status_cobranza.label) filters.push(`Estado: ${this.status_cobranza.label}`);
      if (this.collector && this.collector.label) filters.push(`Cobrador: ${this.collector.label}`);
      if (this.seg_selected && this.seg_selected.label) filters.push(`Segmento: ${this.seg_selected.label}`);
      if (this.ant_selected && this.ant_selected.label) filters.push(`Antiguedad: ${this.ant_selected.label}`);
      if (this.titular_selected && this.titular_selected.label) filters.push(`Titular: ${this.titular_selected.label}`);
      if (this.status_email && this.status_email.label) filters.push(`Envío email: ${this.status_email.label}`);
      if (this.search_field1) filters.push(`Panapass: ${this.search_field1_panapass}`);
      if (this.dateLastPass) filters.push(`Fecha: ${this.customFormat(this.dateLastPass)}`);

      return filters;
    },
  },
  mounted() {
    this.config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.accessToken,
      },
    };
    this.getCompanies();
    this.role = JSON.parse(localStorage.getItem("user_session"));
  },

  methods: {
    calculateSelectPosition(dropdownList, component, coordinates) {
      Object.assign(dropdownList.style, coordinates);
      dropdownList.style.zIndex = "99999";
    },
    customFormat(date) {
      if (!date) return null;
      const d = new Date(date);
      if (isNaN(d)) return null;
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },
    clearFilters() {
      this.search_field1_panapass = "";
      this.search_field1 = "";
      this.ant_selected = null;
      this.seg_selected = null;
      this.dateLastPass = "";
      this.valorTotal = 0;
      this.accountType = { label: "", value: "" };
      this.gestor = { label: "", value: "" };
      this.collector = { label: "", value: "" };
      this.status_cobranza = { label: "", value: "" };
      this.titular_selected = null;
      this.status_email = { label: "", value: "" };
    },
    formatInput(event) {
      const value = event.target.value;
      // Actualiza el valor interno después de eliminar ceros a la izquierda y limitar la longitud
      this.displayValue = value;
      this.search_field1 = this.search_field1_panapass;
    },
    // getRangeDays(){
    //     let me = this
    //     this.$vs.loading()
    //     axios
    //     .get(`auth/getRangeDays?antyday=${this.anty_day}`, this.config )
    //     .then(function (response) {
    //         me.min_range_valid = Math.abs(response.data[0].max_range)
    //         me.min_range = Math.abs(response.data[0].max_range)
    //         me.max_range_valid = Math.abs(response.data[0].min_range)
    //         me.max_range = Math.abs(response.data[0].min_range)
    //         me.$vs.loading.close()
    //     })
    //     .catch(function (error) {
    //         me.$vs.loading.close()
    //     })
    // },
    getCompanies() {
      this.$vs.loading();
      let me = this;
      axios
        .get(`auth/getCompanies`, this.config)
        .then(function (response) {
          me.companies = response.data.data;
          me.antiguedades = response.data.antiguedades;
          me.segmentaciones = response.data.segmentaciones;
          me.fechas = response.data.fechas;
          me.gestores = response.data.gestores_ena;

          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.$vs.loading.close();
        });
    },
    getSearchParams(countOnly = false) {
      let ant_selected = this.ant_selected != null ? this.ant_selected.id : "";
      let seg_selected = this.seg_selected != null ? this.seg_selected.id : "";
      let accountType = this.accountType ? this.accountType.value : '';
      let statusCobranza = this.status_cobranza ? this.status_cobranza.value : '';
      let gestor = this.gestor ? this.gestor.id : '';
      let titular_selected = this.titular_selected != null ? this.titular_selected.value : '';
      let statusEmail = this.status_email ? this.status_email.value : '';

      const dateLastPass = this.customFormat(this.dateLastPass);

      return {
        type_search: this.type_search,
        min_range: this.max_range * -1,
        max_range: this.min_range * -1,
        panapass: this.search_field1,
        ant_selected: ant_selected,
        seg_selected: seg_selected,
        dateLastPass: dateLastPass,
        accountType: accountType,
        gestor: gestor,
        user_id: this.collector.value,
        status_cobranza: statusCobranza,
        titular_selected: titular_selected,
        status_email: statusEmail,
        count_only: countOnly ? 1 : "",
      };
    },
    async validateSearchCount(params) {
      const queryString = Object.keys(params)
        .filter((key) => params[key] !== "" && params[key] !== undefined)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join("&");

      const fullURL = `/auth/getDataCobranza?${queryString}`;
      const response = await axios.get(fullURL, this.config);
      const totalRecords = Number(response.data.total_records || 0);

      if (totalRecords >= 10000) {
        Swal.fire({
          title: "Alerta",
          text: "Ajuste el rango de valores o aplique más filtros para reducir la cantidad de datos a obtener y asegurar el rendimiento.",
          icon: "info",
        });
        return false;
      }

      return true;
    },
    async search_with_filters() {
      if (!this.search_field1) {
        await this.search_cobranza();
        return;
      }

      if (this.search_field1.length != 10) {
        Swal.fire({
          text: "El número de panapass debe tener 10 dígitos",
          icon: "info",
        });
        return;
      }
      await this.search_cobranza();
    },
    async search_cobranza() {
      if (this.isSearching) {
        return;
      }

      this.isSearching = true;
      const params = this.getSearchParams();
      const countParams = this.getSearchParams(true);
      this.$vs.loading();

      try {
        const isValidCount = await this.validateSearchCount(countParams);

        if (!isValidCount) {
          return;
        }

        this.getCollectors();
        this.total_cobranza = 0;
        let baseURL = "/auth/getDataCobranza";

        let queryString = Object.keys(params)
          .filter((key) => params[key] !== "" && params[key] !== undefined)
          .map(
            (key) =>
              `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          )
          .join("&");

        let fullURL = `${baseURL}?${queryString}`;
        const response = await axios.get(fullURL, this.config);

        console.log('response.data: ', response.data.length);
        this.data_cobranza = response.data;

        this.data_cobranza.map((value) => {
          this.total_cobranza += parseFloat(
            Math.abs(value.valorTotal_float)
          );
        });
      } catch (error) {
        console.log(error);
        Swal.fire({
          title: "Ops! algo ha salido mal",
          text: "Intente con un rango de valores más ajustado",
          icon: "info",
        });
        this.data_cobranza = [];
      } finally {
        this.isSearching = false;
        this.$vs.loading.close();
      }
    },
    filteredData(data_cobranza) {
    // agrupa los datos de cobranza por placa y panapass, y para cada grupo mantiene solo el registro más reciente (basado en la fecha gcc_created_at_formated).
      const grouped = {}; // solo los que tienen collector_name
      const others = [];  // los que NO tienen collector_name

      data_cobranza.forEach(curr => {
        const key = `${curr.plate}|${curr.currentOwnerDocumentNumber}|${curr.panapass}`;

        const hasCollector = curr.collector_name && curr.collector_name.trim() !== "";

        if (!hasCollector) {
          others.push(curr);
          return;
        }

        // Si SÍ tiene collector_name
        if (!grouped[key]) {
          grouped[key] = curr;
        } else {
          const d1 = new Date(grouped[key].gcc_created_at_formated);
          const d2 = new Date(curr.gcc_created_at_formated);

          if (d2 > d1) {
            grouped[key] = curr;
          }
        }
      });

      return [...others, ...Object.values(grouped)];
    },
    getCollectors() {
      // this.$vs.loading();
      axios
        .get(`/auth/list`)
        .then((response) => {
          const res = response.data.detail;
          this.collectors = res.map((collector) => {
            return {
              value: collector.id,
              label: collector.names,
            };
          });
        })
        .catch(function (error) {
          console.log(error);
        });

      // me.$vs.loading.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.bar_title {
  background-color: #21409a;
  border-radius: 10px;
  padding: 10px 10px 10px 20px;
  color: white;
  font-size: 2.3vh;
  font-weight: 300;
}

.radio_ant {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 20px; /* Ajusta este valor según tus necesidades */
  height: 20px; /* Ajusta este valor según tus necesidades */
  border-radius: 50%;
  border: 2px solid #787878; /* Cambia el color del borde si lo deseas */
  outline: none;
  cursor: pointer;
}

.radio_ant:checked {
  background-color: #21409a; /* Cambia el color de fondo cuando está seleccionado */
}

.filter-chip {
  background-color: rgba(33, 64, 154, 0.12);
  border: 1px solid rgba(33, 64, 154, 0.2);
  border-radius: 9999px;
  color: #21409a;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.35rem 0.75rem;
}
</style>
